module.exports = __webpack_public_path__ + "static/media/1POLICY30.d1e9acde.jpg";